import {useEffect, useState} from "react";
import {FaArrowDown} from "react-icons/fa"
import {motion} from "framer-motion";
import {IRebound} from "../../utils/interfaces/IRebound";
import DetailsReboundList from "./DetailsReboundList";


interface Props {
    obj: IRebound,
}

function Rebounds({obj: initialObj}: Props) {
    const [obj, setObj] = useState<IRebound>(initialObj)
    const [openDetails, setOpenDetails] = useState<boolean>(false)

    let labelStyle = 'text-sm text-gray-500 font-bold mr-1 cursor-pointer ';
    let contentStyle = 'text-sm text-gray-800 font-bold mr-1 cursor-pointer ';

    useEffect(() => {
        if (initialObj) {
            setObj(initialObj)
        }
    }, [initialObj])

    return (
        <>
            <motion.div
                className="bg-mcia_gray_soft shadow-xl rounded-lg p-4 mb-4 w-[800px] h-[150px] relative"
                initial={{x: '150%'}}
                animate={{x: '0%'}}
                transition={{duration: 0.2}}
            >


                <div className="grid grid-cols-2 gap-2">
                    <div>
                        <h2 className={labelStyle}>Rebounds:</h2>
                    </div>
                    <div>
                        <div className="flex flex-row">
                            <label className={labelStyle}>Amount to be invoiced: </label>
                            <label
                                className={contentStyle}>{obj.totals.restaurant_rebounds_to_invoice_amount.toFixed(2)}</label>
                        </div>

                    </div>
                </div>

                {obj.details.length > 0 ?
                    <button
                        className="cisco_totals_div mb-0.5 w-[200px] absolute bottom-2 left-2 flex items-center justify-between shadow-xl"
                        onClick={() => setOpenDetails(!openDetails)}
                    >
                        {openDetails ? <span>Close Details</span> : <span>Open Details</span>}
                        <span className="mr-2">
                        <FaArrowDown
                            className={openDetails ? 'rotate-180 duration-300' : 'rotate-0 duration-300'}/>
                    </span>
                    </button>
                    : ''}


            </motion.div>

            {openDetails ? <DetailsReboundList obj={obj}/> : ''}
        </>

    )
}

export default Rebounds;